import { AnalyticsEvent } from '../../../../analytics/events/analytics.event'

export class CopyEvent extends AnalyticsEvent {

  constructor (text?: string) {
    let eventAction
    const words = text?.toString()?.split(' ').filter(word => word.length) ?? []
    switch (true) {
      case (words.length <= 3): {
        eventAction = words.join(' ')
        break
      }
      case (words.length <= 6): {
        eventAction = `${words.slice(0, 3).join(' ')}...${words.slice(3).join(' ')}`
        break
      }
      default: {
          eventAction = `${words.slice(0, 3).join(' ')}...${words.slice(words.length - 3).join(' ')}`
        }
      }
    super('productSKU', 'Copy Text', eventAction, '-')
  }
}
